import { isRef, type Ref } from 'vue'
import { hashAny } from '../hash'
import { isUndefined } from '../is'

export const unref = <T = any>(x?: Ref<T> | T): T | undefined | null => {
  if (!x) return x
  return isRef(x) ? unref(x.value) : x
}

export const unrefShallow = <T = any>(x: Ref<T> | T) => isRef(x) ? x.value : x;

export const reactiveKey = (prop: any): string => {
  if (isUndefined(prop) || prop === null) return Math.random().toString()
  if (Array.isArray(prop)) {
    const k = prop as any[]
    return k.map((p) => reactiveKey(p)).join('_')
  }
  if (isRef(prop)) return reactiveKey(prop.value)
  return hashAny(prop)
}
